var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _g, _path8, _path9, _path10, _mask2, _g2, _path11, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlaidBoatHatSelected = function SvgPlaidBoatHatSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 61,
    viewBox: "0 0 88 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2259 5.6847L34.1301 8.55252L38.2259 5.6847ZM51.7022 24.1284L51.4962 19.1327L51.7022 24.1284ZM50.8419 23.7028L54.9377 20.835L50.8419 23.7028ZM70.304 23.8268L71.1878 28.7481L70.304 23.8268ZM70.7887 24.0206L75.4887 25.7266L70.7887 24.0206ZM70.5831 23.7767L69.6994 18.8554L70.5831 23.7767ZM63.4753 42.7679L64.4734 47.6673L63.4753 42.7679ZM64.2157 42.1293L59.5158 40.4233L64.2157 42.1293ZM37.4039 48.0164L38.153 43.0729L37.4039 48.0164ZM37.7533 48.0076L38.7514 52.907L37.7533 48.0076ZM13.1278 43.832L17.7847 42.0119L13.1278 43.832ZM13.9093 44.4567L14.6584 39.5131L13.9093 44.4567ZM6.17663 25.4408L8.34029 20.9332L6.17663 25.4408ZM6.09838 25.1908L6.2562 30.1883L6.09838 25.1908ZM6.05768 25.3837L3.89402 29.8913L6.05768 25.3837ZM21.8097 24.3707L25.5984 27.6334L21.8097 24.3707ZM25.5984 27.6334L41.8044 8.81446L34.2269 2.28904L18.0209 21.1079L25.5984 27.6334ZM6.2562 30.1883L21.2413 29.7151L20.9257 19.7201L5.94057 20.1933L6.2562 30.1883ZM8.34029 20.9332L8.22134 20.8761L3.89402 29.8913L4.01297 29.9484L8.34029 20.9332ZM17.7847 42.0119L10.6999 23.8841L1.38593 27.5243L8.4708 45.6521L17.7847 42.0119ZM38.153 43.0729L14.6584 39.5131L13.1603 49.4002L36.6549 52.96L38.153 43.0729ZM62.4773 37.8686L36.7553 43.1082L38.7514 52.907L64.4734 47.6673L62.4773 37.8686ZM66.0887 22.3147L59.5158 40.4233L68.9157 43.8352L75.4887 25.7266L66.0887 22.3147ZM71.1878 28.7481L71.4669 28.6979L69.6994 18.8554L69.4203 18.9055L71.1878 28.7481ZM51.9083 29.1242L70.3441 28.3639L69.9321 18.3724L51.4962 19.1327L51.9083 29.1242ZM34.1301 8.55252L46.7461 26.5706L54.9377 20.835L42.3217 2.81688L34.1301 8.55252ZM42.3217 2.81688C42.8974 3.63917 43.2063 4.61869 43.2063 5.62251H33.2063C33.2063 6.67083 33.5288 7.69377 34.1301 8.55252L42.3217 2.81688ZM51.4962 19.1327C52.8585 19.0765 54.1556 19.7181 54.9377 20.835L46.7461 26.5706C47.9191 28.246 49.8648 29.2084 51.9083 29.1242L51.4962 19.1327ZM72.9712 27.7685C77.3007 24.9044 75.1184 18.1585 69.9321 18.3724L70.3441 28.3639C65.4119 28.5673 63.3365 22.1521 67.4539 19.4283L72.9712 27.7685ZM69.4203 18.9055C74.6325 17.9695 77.3879 24.8467 72.9712 27.7685L67.4539 19.4283C62.8096 22.5007 65.7069 29.7323 71.1878 28.7481L69.4203 18.9055ZM75.4887 25.7266C76.852 21.9704 73.6324 18.1491 69.6994 18.8554L71.4669 28.6979C67.8132 29.3541 64.8222 25.8041 66.0887 22.3147L75.4887 25.7266ZM64.4734 47.6673C66.5203 47.2504 68.203 45.7988 68.9157 43.8352L59.5158 40.4233C59.9909 39.1142 61.1127 38.1465 62.4773 37.8686L64.4734 47.6673ZM36.6549 52.96C37.3514 53.0656 38.0611 53.0476 38.7514 52.907L36.7553 43.1082C37.2155 43.0145 37.6886 43.0025 38.153 43.0729L36.6549 52.96ZM8.4708 45.6521C9.25161 47.6499 11.0395 49.0789 13.1603 49.4002L14.6584 39.5131C16.0722 39.7273 17.2642 40.68 17.7847 42.0119L8.4708 45.6521ZM6.83888 20.6448C2.98643 20.0931 -0.0307031 23.8996 1.38593 27.5243L10.6999 23.8841C12.0712 27.393 9.15049 31.078 5.42112 30.5438L6.83888 20.6448ZM4.01297 29.9484C-1.05967 27.5136 1.26905 19.8471 6.83888 20.6448L5.42112 30.5438C11.1748 31.3679 13.5803 23.4484 8.34029 20.9332L4.01297 29.9484ZM5.94057 20.1933C0.602593 20.3619 -0.92065 27.5803 3.89402 29.8913L8.22134 20.8761C12.8445 23.0952 11.3818 30.0265 6.2562 30.1883L5.94057 20.1933ZM41.8044 8.81446C38.8446 12.2515 33.2063 10.1582 33.2063 5.62251H43.2063C43.2063 0.885766 37.318 -1.30043 34.2269 2.28904L41.8044 8.81446ZM18.0209 21.1079C18.752 20.2589 19.8058 19.7555 20.9257 19.7201L21.2413 29.7151C22.9211 29.6621 24.5017 28.9069 25.5984 27.6334L18.0209 21.1079Z",
    fill: "#7EC2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3282 33.6395L6 25.322L27.9491 24.6288L23.3282 33.6395Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3282 33.6395L6 25.322L27.9491 24.6288L23.3282 33.6395Z",
    fill: "url(#boat_hat_selected_paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6741 33.4085L48.2808 24.3979L70.6919 23.4737L55.6741 33.4085Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6741 33.4085L48.2808 24.3979L70.6919 23.4737L55.6741 33.4085Z",
    fill: "url(#boat_hat_selected_paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4163 5.51385L15.0874 32.6041L38.4163 40.577V5.51385Z",
    fill: "url(#boat_hat_selected_paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7195 33.0005L38.0484 5.91022V40.9734L14.7195 33.0005ZM38.3375 5.99368L38.2479 41.3448L42.1987 43.7079L58.3715 34.6062L38.3375 5.99368Z",
    fill: "#A51C35"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "boat_hat_selected_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 5,
    width: 45,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7195 33.0005L38.0484 5.91022V40.9734L14.7195 33.0005ZM38.3375 5.99368L38.2479 41.3448L42.1987 43.7079L58.3715 34.6062L38.3375 5.99368Z",
    fill: "#A51C35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#boat_hat_selected_mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.1951,
    y: 5.51388,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.3597,
    y: 12.2517,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 75.3597 12.2517)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.3597,
    y: 19.3858,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 75.3597 19.3858)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.0609,
    y: 5.51388,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.0304,
    y: 4.32486,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8963,
    y: 4.32486,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6297 44.425L6.30804 25.6914L36.571 30.0257L71 23.843L64.1494 42.7166L37.7913 48.0859L13.6297 44.425Z",
    fill: "url(#boat_hat_selected_paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6297 44.425L6.30804 25.6914L36.571 30.0257L71 23.843L64.1494 42.7166L37.7913 48.0859L13.6297 44.425Z",
    fill: "url(#boat_hat_selected_paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3217 44.1167L6 25.3831L36.263 29.7174L70.692 23.5347L63.8413 42.4083L37.4833 47.7776L13.3217 44.1167Z",
    fill: "#A51C35"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "boat_hat_selected_mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 23,
    width: 65,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3217 44.3275L6 25.5939L36.263 29.9282L70.692 23.7455L63.8413 42.6191L37.4833 47.9884L13.3217 44.3275Z",
    fill: "#A51C35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#boat_hat_selected_mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.5427,
    y: 18.5931,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.8171,
    y: 18.5931,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9817,
    y: 25.3309,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 72.9817 25.3309)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9817,
    y: 32.465,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 72.9817 32.465)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4085,
    y: 18.5931,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.6829,
    y: 18.5931,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4126 39C69.8926 39 65.4126 43.48 65.4126 49C65.4126 54.52 69.8926 59 75.4126 59C80.9326 59 85.4126 54.52 85.4126 49C85.4126 43.48 80.9326 39 75.4126 39ZM72.7026 53.29L69.1126 49.7C68.7226 49.31 68.7226 48.68 69.1126 48.29C69.5026 47.9 70.1326 47.9 70.5226 48.29L73.4126 51.17L80.2926 44.29C80.6826 43.9 81.3126 43.9 81.7026 44.29C82.0926 44.68 82.0926 45.31 81.7026 45.7L74.1126 53.29C73.7326 53.68 73.0926 53.68 72.7026 53.29Z",
    fill: "#7EC2E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint0_linear",
    x1: 16.9745,
    y1: 24.6288,
    x2: 16.9745,
    y2: 33.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint1_linear",
    x1: 59.4863,
    y1: 23.4737,
    x2: 59.4863,
    y2: 33.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint2_linear",
    x1: 33.4933,
    y1: -4.65173,
    x2: 33.9554,
    y2: 69.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint3_linear",
    x1: 38.6531,
    y1: 9.57984,
    x2: 38.6531,
    y2: 41.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint4_linear",
    x1: 38.6531,
    y1: 15.5868,
    x2: 38.6531,
    y2: 59.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaidBoatHatSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plaid_boat_hat_selected.e7a3c059.svg";
export { ForwardRef as ReactComponent };